import {
  AfterViewChecked,
  Directive,
  ElementRef,
  inject,
} from '@angular/core';

@Directive({
  selector: '[liberroRevealHtml]',
})
export class RevealHtmlDirective implements AfterViewChecked {
  private initialized = false;

  private readonly el = inject(ElementRef<HTMLElement>);

  public ngAfterViewChecked(): void {
    if (this.initialized || !this.el.nativeElement.textContent?.trim()) {
      return;
    }

    this.initialized = true;
    this.revealWords();
  }

  private revealWords() {
    const root = this.el.nativeElement;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
    );

    const textNodes: Text[] = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode as Text);
    }

    // First collect all words so we know the total count.
    const parts = textNodes.map(node =>
      (node.textContent ?? '').match(/\S+|\s+/g) ?? []
    );

    const wordCount = parts.reduce(
      (count, parts) =>
        count + parts.filter(part => !/^\s+$/.test(part)).length,
      0,
    );

    const totalDuration = 500;
    const delay = wordCount > 1
      ? totalDuration / wordCount
      : 0;

    let index = 0;

    textNodes.forEach((node, nodeIndex) => {
      const fragment = document.createDocumentFragment();

      for (const part of parts[nodeIndex]) {
        if (/^\s+$/.test(part)) {
          fragment.appendChild(
            document.createTextNode(part),
          );
          continue;
        }

        const span = document.createElement('span');

        span.className = 'reveal-word';
        span.textContent = part;
        span.style.animationDelay = `${index * delay}ms`;

        fragment.appendChild(span);

        index++;
      }

      node.replaceWith(fragment);
    });
  }
}